import { errorTypes, redirectOptions } from "../config/constants";

export const colorhandler = (error: string) => {
  switch (error) {
    case errorTypes.Mispronunciation:
      return "bg-yellow-500 p-1 text-white";
    case errorTypes.Omission:
      return "bg-gray-500 p-1 text-white";
    case errorTypes.Insertion:
      return "bg-red-500 p-1 text-white";
    case errorTypes.UnexpextedBreak:
      return "bg-pink-500 p-1 text-white";
    case errorTypes.MissingBreak:
      return "bg-gray-300 p-1 text-white";
    case errorTypes.Monotone:
      return "bg-blue-500 p-1 text-white";
    default:
      return "p-1 ";
  }
};
export const totalPages = (totalRows: number, limit: number) => {
  return Math.ceil(totalRows / limit);
};

export const getLocalTime = (utcDate: string) => {
  const istTimestamp = new Date(
    new Date(utcDate).getTime() + 5.5 * 60 * 60 * 1000
  );
  const formattedDate =
    istTimestamp.getDate() +
    " " +
    istTimestamp.toLocaleString("default", { month: "short" }) +
    " " +
    istTimestamp.getFullYear() +
    " " +
    (istTimestamp.getHours() < 10 ? "0" : "") +
    istTimestamp.getHours() +
    ":" +
    (istTimestamp.getMinutes() < 10 ? "0" : "") +
    istTimestamp.getMinutes();
  return formattedDate;
};

export const handlingAppName = (appCode?: string) => {
  const matchingRedirect = redirectOptions.filter(
    (redict) => redict.source === appCode
  )[0];

  const matchingName = matchingRedirect ? matchingRedirect.name : "_";
  return matchingName;
};
